<template>
  <mdb-container v-if="group && event">
    <banner-small :group="group" :title="event.title + ' Gallery'" v-if="event && group"/>
    <div class="text-left" v-if="event.images && event.images.length==0">
      No images have been added yet.
    </div>
    <div v-if="showListView">
      <mdb-btn @click="uploadPhotos" color="success" icon="images" v-if="readyToUpload && !uploading">Upload Now
      </mdb-btn>
      <mdb-btn @click="$router.push('/event/show/' + id)" icon="arrow-left">Event</mdb-btn>
      <mdb-btn @click="showUpload=true" icon="plus-circle" v-if="group && group.role != 'Public' && !showUpload">Add
        photo(s)
      </mdb-btn>
      <mdb-btn @click="downloadAll" icon="download"
               v-if="group && group.role != 'Public' && !showUpload && event.isAdmin">Download Gallery
      </mdb-btn>
      <mdb-btn @click="allGalleries" icon="images" v-if="group && group.role != 'Public' && !showUpload">Group
        Galleries
      </mdb-btn>
      <mdb-btn @click="showUpload=false" color="warning" icon="times-circle" v-if="showUpload && !uploading">Cancel
      </mdb-btn>
      <mdb-file-upload :disabled="uploading" :files="files" @change="handleChange" multiple v-if="showUpload"/>
    </div>
    <mdb-row v-if="showListView">
      <div :id="'image-'+i" :key="i" class="col-md-3 d-flex align-self-stretch" v-for="(image,i) in event.images">
        <mdb-card class="face front mb-4 animated rotateIn">
          <mdb-view hover zoom>
            <a @click.prevent="showImage(i)" href="">
              <mdb-card-image
                :src="image.thumbUrl"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
            </a>
            <div class="small" v-if="group && group.role != 'Public'">
              By: {{ image.by }}
            </div>
          </mdb-view>
          <mdb-card-body>

            <div v-if="group && group.role != 'Public'">
              <div class="text-info" v-if="image.caption">
                {{ image.caption }}
              </div>

              <mdb-btn @click="comments(image,i)" floating icon="comments"
                       size="sm" slot="reference"
                       tag="a"
                       type="">
              </mdb-btn>
              <mdb-badge class="image-button-badge" v-if="image.social.comments > 0">{{
                  image.social.comments
                }}
              </mdb-badge>

              <mdb-btn @click="deleteImage(image)" color="danger" floating icon="trash" size="sm"
                       slot="reference"
                       tag="a"
                       type="" v-if="image.allowDelete"/>
              <a @click.prevent="like(image)" href="" title="Like" v-if="!image.memberLikes">
                <mdb-icon class="text-black-50" fal icon="thumbs-up" size="lg"></mdb-icon>
              </a>
              <mdb-badge v-if="image.social.likes > 0 && !image.memberLikes">{{ image.social.likes }}</mdb-badge>
              <mdb-btn @click="unlike(image)" fas floating icon="thumbs-up" size="sm" slot="reference" tag="a"
                       title="Unlike"
                       type="" v-if="image.memberLikes"/>
              <mdb-badge class="image-button-badge" v-if="image.social.likes > 0 && image.memberLikes">
                {{ image.social.likes }}
              </mdb-badge>
              <mdb-btn @click="toggleSlideshow(image)" icon="images" rounded
                       size="sm" v-if="!image.includedInSlideshow && group.role=='Admin'">+ Slideshow
              </mdb-btn>
              <mdb-btn @click="toggleSlideshow(image)" color="warning" icon="images" rounded
                       size="sm" v-if="image.includedInSlideshow && group.role=='Admin'">- Slideshow
              </mdb-btn>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>
    </mdb-row>

    <mdb-card class="face front mb-4 animated fadeInDown" v-if="showSingleView">
      <div class="back-container">
        <mdb-btn :left="25" :top="30" @click="viewList" floating icon="arrow-left"
                 size="lg"
                 tag="a" type="" waves/>
      </div>
      <mdb-card-body>
        <h3 v-if="(currentImage.caption || currentImage.allowDelete) && !editCaption">
          {{ currentImage.caption ? currentImage.caption : 'Untitled' }}
          <mdb-btn @click="openCaption" floating icon="pencil" size="sm"
                   :title="currentImage.caption ? 'Edit Caption' : 'Add a Caption'"
                   tag="a"
                   type="" v-if="currentImage.allowDelete"/>
        </h3>
        <div class="card-body" style="width:50%; margin:auto;" v-if="editCaption">
          <mdb-input :disabled="savingCaption" @keydown.native="watchForEnter" id="captionInput"
                     placeholder="Caption for Image"
                     type="text" v-model="workingCaption"/>
          <mdb-btn :disabled="!workingCaption" @click="saveCaption"
                   floating
                   icon="save" size="sm" tag="a" type=""/>
          <mdb-btn @click="cancelCaption" color="danger"
                   floating
                   icon="times-circle" size="sm" tag="a" type=""/>

        </div>
        <div class="image-container">
          <mdb-view class="zoom overlay">
            <!--a :href="currentImage.imageUrl" target="_blank"><img :src="currentImage.imageUrl" class="center-fit waves"/></a>-->
            <a @click.prevent="showImage(currentImageIndex)" href="">
              <img :src="currentImage.imageUrl" class="center-fit waves"/>
            </a>
          </mdb-view>
        </div>
        <div>
          <div>
            <avatar :avatar="currentImage.avatar" :size="50" containerClass="text-center"/>
            Photo by {{ currentImage.by }}
          </div>
          <div>
            <mdb-btn @click="deleteImage(currentImage)" color="danger" floating icon="trash"
                     size="sm"
                     slot="reference" tag="a"
                     type="" v-if="currentImage.allowDelete"/>
            <a @click.prevent="like(currentImage)" href="" title="Like" v-if="!currentImage.memberLikes">
              <mdb-icon class="text-black-50" fal icon="thumbs-up" size="lg"></mdb-icon>
            </a>
            <mdb-btn @click="unlike(currentImage)" fas floating icon="thumbs-up" size="sm" slot="reference"
                     tag="a"
                     title="Unlike"
                     type="" v-if="currentImage.memberLikes"/>
            <a @click.prevent="showLikes(currentImage)" href=""
               v-if="currentImage.social.likes >0">
              {{ currentImage.social.likes }} {{ currentImage.social.likes > 1 ? "likes" : "like" }}</a>
          </div>
          <div>
            <mdb-btn @click="toggleSlideshow(currentImage)" icon="images" rounded
                     size="sm" v-if="!currentImage.includedInSlideshow && group.role=='Admin'">+ Slideshow
            </mdb-btn>
            <mdb-btn @click="toggleSlideshow(currentImage)" color="warning" icon="images" rounded
                     size="sm" v-if="currentImage.includedInSlideshow && group.role=='Admin'">- Slideshow
            </mdb-btn>
            <mdb-btn @click="showTagsModal=true" icon="tags" rounded
                     size="sm" v-if="event.isAdmin">Tags
            </mdb-btn>
          </div>
        </div>
        <messaging :id="currentImage.id" type="image"/>

      </mdb-card-body>
    </mdb-card>

    <yes-no-modal @no="deletePending = null"
                  @yes="deleteConfirmed"
                  question="Are you sure you wish to delete this image?" v-if="deletePending"/>

    <mdb-modal :show="showLikesModal" @close="showLikesModal = false" size="lg">
      <mdb-modal-header :close="true" class="primary-color text-center text-white">
        <h5>Liked By</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <span v-for="m in likes">
            <mdb-chip :alt="m.name" :src="m.profile" waves>
              {{ m.name }}
            </mdb-chip>
          </span>
        </mdb-row>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="downloadModal" @close="downloadModal = false" size="lg">
      <mdb-modal-header :close="true" class="primary-color text-center text-white">
        <h5>Download All</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div class="mb-2">You are about to download all the images in this gallery.</div>
        <div class="mb-2">Before you begin, check your browser settings:</div>
        <ul>
          <li>Make sure you are not prompted for the destination folder for each file.</li>
          <li>Ensure the default download directory is set where you want the files to go. You may wish to change this
            temporarily when downloading a very large gallery.
          </li>
        </ul>
        <mdb-btn @click="downloadAll" icon="download"
                 v-if="group && group.role != 'Public' && !showUpload && event.isAdmin">Download Now
        </mdb-btn>

      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal @close="showTagsModal = false" size="lg" v-if="showTagsModal">
      <mdb-modal-header :close="true" class="primary-color text-center text-white">
        <h5>Tags</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="text-left">
          <div style="font-size: .9rem; color: #757575;">Tags</div>
          <cust-chip-input :chips="currentImage.tags" id="chip-input"/>
          <div>
            <small>Tagged event images can be selected for use in event and venue descriptions.</small>
          </div>
          <mdb-btn @click="saveTags" icon="save">Save</mdb-btn>
          <mdb-btn @click="showTagsModal = false" icon="times-plus">Cancel</mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>

    <cust-lightbox :imgs="slideshowImages" :index="lbIndex" :visible="slideshowVisible"
                   @hide="slideshowVisible=false"></cust-lightbox>

  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import mdbFileUpload from 'mdbvue-file-upload'
import {mapState} from "vuex";
import CustChipInput from "../common/CustChipInput";
import CustLightbox from "../common/CustLightbox";
import {
  mdbBadge,
  mdbBtn,
  mdbBtnFixed,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCarousel,
  mdbChip,
  mdbContainer,
  mdbFlippingCard,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbView
} from 'mdbvue';
import BannerSmall from "../group/BannerSmall"
import Messaging from "../common/Messaging";
import yesNoModal from "../common/YesNoModal";
import Avatar from "../common/Avatar";
import Vue from "vue";
import FileSaver from 'file-saver'

export default {
  name: 'Event-Gallery',
  components: {
    mdbBtn,
    mdbBtnFixed,
    mdbCard,
    mdbCardBody,
    mdbCardFooter,
    mdbCardGroup,
    mdbCardHeader,
    mdbCardImage,
    mdbCardText,
    mdbCardTitle,
    mdbCarousel,
    mdbChip,
    mdbContainer,
    mdbInput,
    mdbIcon,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbRow,
    mdbFlippingCard,
    mdbView,
    mdbMask,
    mdbFileUpload,
    mdbBadge,
    BannerSmall,
    Messaging,
    yesNoModal,
    Avatar,
    CustChipInput,
    CustLightbox
  },
  data() {
    return {
      event: {},
      id: null,
      deletePending: null,
      showListView: true,
      showSingleView: false,
      currentImage: null,
      currentImageIndex: 0,
      editCaption: false,
      savingCaption: false,
      workingCaption: null,
      showLikesModal: false,
      showTagsModal: false,
      slideshowImages: [],
      slideshowVisible: false,
      listScrollPos: 0,
      lbIndex: 0,
      showUpload: false,
      readyToUpload: false,
      uploading: false,
      gotError: false,
      files: [],
      likes: [],
      downloadModal: false,
      downloadSize: 0,
      downloaded: 0
    }
  },
  computed: mapState({
                       group: state => state.currentGroup,
                       userDetails: state => state.userDetails
                     }),
  mounted() {
    this.id = this.$route.params.id
    if (this.$route.query.event) this.id = this.$route.query.event
    this.loadEvent(false)
  },
  watch: {
    downloaded(n, o) {
      if (n > 0 && this.downloadSize > 0) {
        if (this.downloaded >= this.downloadSize) {
          this.$store.dispatch("setExecuting", false)
          this.downloadSize = 0
          this.downloaded = 0
        }
      }
    }
  },
  methods: {
    allGalleries() {
      this.$router.push("/group/" + this.group.vanityPath + "/galleries")
    },
    handleChange(x) {
      if (this.files.length > 0) this.readyToUpload = true
      else this.readyToUpload = false
    },
    async uploadPhotos() {
      this.uploading = true
      this.showUpload = false
      this.readyToUpload = false
      const reduce = require('image-blob-reduce')();
      await this.$store.dispatch("setExecuting", true)
      this.gotError = false
      for (let image of this.files) {
        if (!this.gotError) {
          if (image.type.indexOf("image/") != 0) {
            this.$notify.error({message: "Only images are allowed", timeOut: 5000})
            this.$store.dispatch("setExecuting", false)
            return
          }
          if (image.size >= 2000000) {
            await reduce.toBlob(image, {max: 2000})
              .then(blob => {
                image.file = blob
              })
          }

          let uploadResults = await api.groupUploadImage(this.group.id, image)

          if (!uploadResults.success) {
            this.gotError = true
            this.showUpload = true
            this.$notify.error({message: uploadResults.message, timeOut: 5000})
            this.uploading = false
            return
          }

          await api.post("/event/galleryImage/" + this.event.id, uploadResults.uploadRequest).then(
            (results) => {
              this.event.images.unshift(results.data)
              this.slideshowImages.unshift({
                                             img: results.data.imageUrl,
                                             thumbnail: results.data.thumbnail,
                                             filename: image.filename,
                                             caption: "Image Credit: " + results.data.by
                                           })
            },
            (error) => {
              this.gotError = true
              this.showUpload = true
              this.$notify.error({message: error.response.data, timeOut: 5000})
            }).then(() => {
            this.uploading = false
          })
        }
      }
      this.files = []
      await this.$store.dispatch("setExecuting", false)
    },
    showLikes() {
      this.$store.dispatch("setExecuting", true)
      let url = "/image/likes/" + this.currentImage.id
      api.get(url).then(
        (results) => {
          this.likes = results.data.likes
          this.showLikesModal = true
        },
        (error) => {
          this.$notify.error({message: "Could not get likes. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    openCaption: function () {
      this.workingCaption = this.currentImage.caption
      Vue.nextTick().then(function () {
        let el = document.getElementById("captionInput")
        if (el) el.focus()
      })
      this.editCaption = true
    },
    cancelCaption: function () {
      this.workingCaption = ""
      this.editCaption = false
    },
    watchForEnter: function (k) {
      if (k.keyCode == 13 && this.workingCaption != "") this.saveCaption()
    },
    saveCaption: function () {
      this.savingCaption = true
      api.post("/image/caption/" + this.currentImage.id, {caption: this.workingCaption}).then(
        (details) => {
          this.currentImage.caption = this.workingCaption
          this.workingCaption = ""
          this.editCaption = false
        },
        (error) => {
          this.$notify.error({message: "Error captioning image."})
        }).then(() => {
        this.savingCaption = false
      })
    },
    saveTags: function () {
      this.showTagsModal = false
      this.$store.dispatch("setExecuting", true);
      api.post("/image/tags/" + this.currentImage.id, {tags: this.currentImage.tags}).then(
        (details) => {

        },
        (error) => {
          this.$notify.error({message: "Error tagging image."})
          this.showTagsModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false);
      })
    },
    loadEvent: function () {
      this.$store.dispatch("setExecuting", true);
      api.get("/event/gallery/" + this.id).then(
        (results) => {
          this.event = results.data;
          if (!this.group || this.group.id != this.event.groupId) {
            api.groupBasics(this.event.groupId, "public");
          }
          document.title = this.event.title;
          this.buildSlideshow()
          if (this.$route.query.event) this.openFromLink()
          api.trackGroupVisit(this.event.groupId)
        },
        (error) => {
          if (error.response.status == 403 || error.response.status == 401) {
            this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
            return
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    buildSlideshow() {
      this.slideshowImages = []
      this.event.images.forEach(img => {
        this.slideshowImages.push({
                                    img: img.imageUrl,
                                    thumbnail: img.thumbnail,
                                    caption: (img.caption ? img.caption : '') + ' Image Credit: ' + img.by,
                                    downloadUrl: img.downloadUrl,
                                    filename: img.filename,
                                    id: img.id
                                  })
      })

    },
    like(image) {
      this.$store.dispatch("setExecuting", true);
      api.get("/image/like/" + image.id).then(
        (results) => {
          image.memberLikes = true
          image.social.likes++
        },
        (error) => {
          this.$notify.error({message: error.response.data.message, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    unlike(image) {
      this.$store.dispatch("setExecuting", true);
      api.get("/image/unlike/" + image.id).then(
        (results) => {
          image.memberLikes = false
          image.social.likes--
        },
        (error) => {
          this.$notify.error({message: error.response.data.message, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    toggleSlideshow: function (image) {
      this.$store.dispatch("setExecuting", true);
      api.get("/image/toggleSlideshow/" + image.id, {}).then(
        (details) => {
          image.includedInSlideshow = !image.includedInSlideshow
        },
        (error) => {
          this.$notify.error({message: "Error editing slideshow."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteImage: function (image) {
      this.deletePending = image
    },
    deleteConfirmed: function () {
      this.$store.dispatch("setExecuting", true);
      api.delete("/image/eventImageDelete/" + this.deletePending.id, {}).then(
        (details) => {
          let loc = this.event.images.indexOf(this.deletePending)
          this.event.images.splice(loc, 1)
          this.deletePending = null
          this.currentImage = null
          this.showSingleView = false
          this.showListView = true
          this.buildSlideshow()
        },
        (error) => {
          this.$notify.error({message: "Error deleting image."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    showImage: function (i) {
      this.lbIndex = i
      this.slideshowVisible = true
    },
    comments: function (image, i) {
      this.showListView = false
      this.showSingleView = true
      this.currentImage = image
      this.currentImageIndex = i
      let el = document.getElementById("image-" + i)
      if (el) this.listScrollPos = el.offsetTop - 40
      this.$nextTick().then(() => {
        window.scrollTo(0, 0)
      })
    },
    viewList: function () {
      this.showListView = true
      this.showSingleView = false
      this.currentImage = null
      if (this.$route.query.highlight || this.$route.query.event) this.$router.replace("/event/gallery/" + this.id)
      this.$nextTick().then(() => {
        window.scrollTo(0, this.listScrollPos)
      })
    },
    openFromLink: function () {
      //if (this.$route.query.event) this.id = this.$route.query.event
      let requested = this.$route.params.id
      for (let i = 0; i < this.event.images.length; i++) {
        if (this.event.images[i].id == requested) this.currentImage = this.event.images[i]
      }
      this.showListView = false
      this.showSingleView = true
    },
    downloadAll: function () {
      if (!this.downloadModal) {
        this.downloadModal = true
        return
      }
      this.$store.dispatch("setExecuting", true);
      this.downloadModal = false

      api.get("/event/imageListForDownload/" + this.event.id).then(
        (details) => {
          this.downloadSize = details.data.length
          details.data.forEach(img => {
            fetch(img.url)
              .then(res => res.blob())
              .then(blob => {
                FileSaver.saveAs(blob, img.name);
                this.downloaded++
              });

          });
        },
        (error) => {
          this.$notify.error({message: "Error getting gallery details."})
          this.$store.dispatch("setExecuting", false)
        }
      )
    }
  }
}
</script>
<style scoped>
.image-container {
  display: grid;
  height: 80%
}

.center-fit {
  max-width: 100%;
  max-height: 50vh;
  margin: auto;
}

.image-container img {
  object-fit: contain;
}

.back-container {
  position: absolute;
  top: 0;
  left: 0;
}

.image-button-badge {
  margin-left: -13px;
}

</style>
